import type { Filter, NostrEvent } from "applesauce-core/helpers";
import "window.nostrdb.js";
import {
  isPrivateRelayEvent,
  isRepositoryRelatedEvent,
} from "./privateRepoAccess";

/**
 * Request events from the IndexedDB cache.
 * Used by event loaders to check cache before querying relays.
 * Returns empty array if cache is not available.
 */
export async function cacheRequest(filters: Filter[]) {
  const events = await window.nostrdb.filters(filters);
  return events.filter(
    (event) => !isRepositoryRelatedEvent(event) && !isPrivateRelayEvent(event),
  );
}

/** Save events to the cache */
export async function saveEvents(events: NostrEvent[]) {
  await Promise.allSettled(
    events
      .filter(
        (event) =>
          !isRepositoryRelatedEvent(event) && !isPrivateRelayEvent(event),
      )
      .map((event) => window.nostrdb.add(event)),
  );
}

/**
 * Remove events that became private after recursive maintainer resolution.
 *
 * NIP-DB does not standardize deletion. The bundled IndexedDB implementation
 * exposes deletion on its backend; other backends remain protected by the
 * read/write classifier even when they cannot physically purge.
 */
export async function purgeEventsFromCache(_events: NostrEvent[]) {
  // Repository events never enter persistent storage. NIP-DB does not expose a
  // portable delete operation and nostr-idb deletion cannot cancel its pending
  // write queue, so attempting best-effort deletion here would provide a false
  // security guarantee. cacheRequest() excludes legacy entries fail-closed.
}
